/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { AbstractControl, AsyncValidatorFn, FormArray, ValidatorFn } from '@angular/forms';
import { ControlSchemaPackedValue } from '../form-schema';
import { FormArraySchema, FormArraySchemaConfig } from '../form-schema/form-array-schema';
import { AppControl } from './app-control';

export class AppFormArray extends FormArray implements AppControl {
  key?: string;
  required: boolean;
  visible: boolean;
  privileged: boolean;
  lastValidators?: ValidatorFn[];
  lastAsyncValidators?: AsyncValidatorFn[];

  constructor(private schema: FormArraySchema,
              controls: AbstractControl[], validator?: ValidatorFn,
              asyncValidator?: AsyncValidatorFn) {
    super(controls, validator, asyncValidator);
    this.key = schema.key;
  }

  updateSchema(config: FormArraySchemaConfig, packedValue?: ControlSchemaPackedValue): void {
    this.schema.update(config);
    this.schema.applyTo(this, packedValue);
  }
}
